module.exports = __webpack_public_path__ + "static/media/wtw_new_logo_white.7f769b25.svg";